module.exports = __webpack_public_path__ + "img/qrcode-sample.24b95831.svg";